__turbopack_context__.v({
  "content": "rDJ0ca_content",
  "item": "rDJ0ca_item",
  "root": "rDJ0ca_root",
  "trigger": "rDJ0ca_trigger",
});
